// extracted by mini-css-extract-plugin
export default {"logoList_big_container":"logoList-module--logoList_big_container--VOUL7","logoList_container":"logoList-module--logoList_container--UyY8C","logo":"logoList-module--logo--n948d"};